import { getStateLogoUrl } from "@/lib/state-logos";
import { slugToColor } from "@/lib/game-logos";

interface StateLogoProps {
  stateSlug: string;
  abbreviation: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeMap = {
  sm: "h-8 w-8 text-xs",
  md: "h-10 w-10 text-sm",
  lg: "h-14 w-14 text-lg",
};

export function StateLogo({ stateSlug, abbreviation, size = "md", className = "" }: StateLogoProps) {
  const logoUrl = getStateLogoUrl(stateSlug);
  const sizeClass = sizeMap[size];

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={`${abbreviation} lottery logo`}
        className={`${sizeClass} object-contain rounded ${className}`}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} rounded-full flex items-center justify-center font-bold text-white shrink-0 ${className}`}
      style={{ backgroundColor: slugToColor(stateSlug) }}
      aria-label={`${abbreviation} lottery`}
    >
      {abbreviation}
    </div>
  );
}
